import React from 'react';
import LiteratureMonoHtmlView from './LiteratureHtml';
import LiteratureMonoReactView from './Literature';
const LiterartureMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(LiteratureMonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(LiteratureMonoReactView, props);
};
LiterartureMonoView.displayName = 'LiterartureMonoView';
export default LiterartureMonoView;
